import { render, staticRenderFns } from "./list-item-file-pxmaterial.vue?vue&type=template&id=42e8c1a2&scoped=true"
import script from "./list-item-file-pxmaterial.vue?vue&type=script&lang=js"
export * from "./list-item-file-pxmaterial.vue?vue&type=script&lang=js"
import style0 from "./list-item-file-pxmaterial.vue?vue&type=style&index=0&id=42e8c1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e8c1a2",
  null
  
)

export default component.exports